<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.solventInspection_MarkingTestDetail"
      >
        <span
          class="col-form-label"
        >Perform Device Marking Test (for remarking - Mineral Spirits and Alcohol swab</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.solventInspection_SurfaceTestDetail"
      >
        <span
          class="col-form-label"
        >Perform Device Surface Test (test for blacktopping -Acetone swab</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Pass', 'Fail', 'N/A']"
        v-model="model.solventInspection_ScrapeTestDetail"
      >
        <span class="col-form-label">Perform scrape test</span>
      </b-form-radio-group>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'ideaSolventsDetailed',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        solventInspection_MarkingTestDetail: this.inspectionDetails[FIELDS.SOLVENT_INSPECTION__MARKING_TEST_DETAIL] || '',
        solventInspection_SurfaceTestDetail: this.inspectionDetails[FIELDS.SOLVENT_INSPECTION__SURFACE_TEST_DETAIL] || '',
        solventInspection_ScrapeTestDetail: this.inspectionDetails[FIELDS.SOLVENT_INSPECTION__SCRAPE_TEST_DETAIL] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>